import { Injectable } from '@angular/core';
import { Router } from '@angular/router';
import { declarePersistable } from 'serialijse';
import {
  ModelConfig,
  ProductConfig,
  BtnToggleConfig,
  DeliveryPriceConfigITA,
  DeliveryPriceConfigEXT,
  DeliveryOption,
  PaymentOption,
  PaymentType,
  Address,
  Cart,
  CartProduct,
  Customer,
  Param
} from './models';


export class FormatConfig {
  id: number;
  idformatGroup: number;
  name: string;
}



@Injectable()
export class ConfigService {
  private dpiMin: number = 60; // prima era 72dpi
  private inchToCm: number = 2.54;
  public RappRisoluzMin: number = this.dpiMin / this.inchToCm; // 28.346; // = 72dpi/2.54
  public isModeZodio: boolean = false;
  public debug: boolean;
  public apiUrl: string;
  public urlHost: string;
  public outputBaseUrl: string;
  public imagesUrl: string;
  public partialsUrl: string;
  public pdfUrl: string;
  public i18nUrl: string;
  public braintreeTokenUrl: string;
  public models: ModelConfig[];
  public btnToggles: BtnToggleConfig[];
  public products: ProductConfig[];

  public imageMap: any = [];
  public topAffixOffset: number = 42;

  public shipmentNations: any[];
  public paymentOptions: PaymentOption[];
  public paymentOptionsCampionario: PaymentOption[];
  public deliveryOptions: DeliveryOption[];
  public deliveryPricesItaly: DeliveryPriceConfigITA[];
  public deliveryPricesEXT: DeliveryPriceConfigEXT[];
  public deliveryFissi: string[];
  public campionarioPrice = 20;


  // Parametri da passare come pre-filtri al cambio di prodotto
  public paramsToSaveKeys = [
    'FormatoGruppo',
    'Formato',
    'FormatoOrientamento',
    // 'ListaFormati', // no perchè cambia il prezzo tra un prodotto e l'altro
    'Cornice',
    'SistemaFissaggio'
  ];

  setPersistable(): void {
    declarePersistable(Cart);
    declarePersistable(CartProduct);
    declarePersistable(Address);
    declarePersistable(Customer);
    declarePersistable(ModelConfig);
    declarePersistable(Param);
  }
  constructor(
    private router: Router,
    // public cartService: CartService
  ) {
    this.debug = process.env.ENV !== 'build';

    // this.debug = false;


    this.urlHost = this.debug
      // ? 'http://localhost:57136/'
      ? 'http://localhost:57136/' // ? 'http://www.topcolor.it/'
      : 'https://shop.topcolor.it/';

    // URLS
    let apiHost = this.debug
      // ? 'http://localhost:64571/'
      ? 'http://localhost:64571/' // ? 'http://api.ctopcolor.coriweb.it/'
      : 'https://api.topcolor.it/';

    let filesHost = this.debug
      // ? 'http://localhost:57136/files/'
      ? 'http://localhost:57136/files/' // ? 'http://www.topcolor.it/files/'
      : 'https://shop.topcolor.it/files/';

    this.outputBaseUrl = this.debug
      ? this.urlHost + '{lang}/configurator-output'
      : '/{lang}/configurator-output';

    this.apiUrl = `${apiHost}api`;
    this.imagesUrl = `${this.urlHost}Content/images/configurator`;
    this.partialsUrl = `${filesHost}app/partials`;
    this.pdfUrl = `${filesHost}pdf`;
    this.i18nUrl = `${filesHost}i18n`;

    this.braintreeTokenUrl = `${this.urlHost}/generate-braintree-token.axd`;


    // PaymentOption
    this.paymentOptions = [
      { key: PaymentType.Braintree, name: 'Paypal o carta di credito' },
      { key: PaymentType.Bank, name: 'Bonifico bancario' }
    ];
    // PaymentOption Campionario
    this.paymentOptionsCampionario = [
      { key: PaymentType.Braintree, name: 'Paypal o carta di credito' },
      { key: PaymentType.Bank, name: 'Bonifico bancario' }
    ];

    // DeliveryOption
    this.deliveryOptions = [
      { id: 1, name: 'Corriere Espresso' },
      { id: 2, name: 'Ritiro in Sede' }
    ];

    // DeliveryPrice BARTOLINI ITALIA
    this.deliveryPricesItaly = [
      { rangeMinKg: 0, rangeMaxKg: 3, price: 6.9 },
      { rangeMinKg: 3, rangeMaxKg: 10, price: 9.3 },
      { rangeMinKg: 10, rangeMaxKg: 20, price: 11.7 },
      { rangeMinKg: 20, rangeMaxKg: 30, price: 14.4 },
      { rangeMinKg: 30, rangeMaxKg: 999, price: 16.5 }
    ];

    // DeliveryPrice BARTOLINI ESTERO
    // this.deliveryPricesEXT = deliveryPricesEXTJS;
    this.deliveryPricesEXT = [
      { nation: 'Germania', range_0_5kg: 10.35, range_5_15kg: 12.65, range_15_31_5kg: 16.70, oltre_31_5kg_alKG: 0.36 },
      { nation: 'Austria', range_0_5kg: 10.35, range_5_15kg: 13.85, range_15_31_5kg: 16.65, oltre_31_5kg_alKG: 0.40 },
      { nation: 'Olanda', range_0_5kg: 11.40, range_5_15kg: 16.25, range_15_31_5kg: 19.65, oltre_31_5kg_alKG: 0.44 },
      { nation: 'Belgio', range_0_5kg: 10.35, range_5_15kg: 15.50, range_15_31_5kg: 18.60, oltre_31_5kg_alKG: 0.44 },
      { nation: 'Lussemburgo', range_0_5kg: 10.35, range_5_15kg: 15.50, range_15_31_5kg: 18.60, oltre_31_5kg_alKG: 0.44 },
      { nation: 'Bosnia and Herz.- Croazia', range_0_5kg: 14.05, range_5_15kg: 19.30, range_15_31_5kg: 26.20, oltre_31_5kg_alKG: 0.44 },
      { nation: 'Ungheria', range_0_5kg: 12.60, range_5_15kg: 19.30, range_15_31_5kg: 23.40, oltre_31_5kg_alKG: 0.44 },
      { nation: 'Montenegro', range_0_5kg: 14.25, range_5_15kg: 20.00, range_15_31_5kg: 27.70, oltre_31_5kg_alKG: 0.48 },
      { nation: 'Serbia', range_0_5kg: 14.05, range_5_15kg: 19.30, range_15_31_5kg: 26.20, oltre_31_5kg_alKG: 0.44 },
      { nation: 'Slovacchia', range_0_5kg: 14.05, range_5_15kg: 18.65, range_15_31_5kg: 21.60, oltre_31_5kg_alKG: 0.44 },
      { nation: 'Slovenia', range_0_5kg: 13.70, range_5_15kg: 19.20, range_15_31_5kg: 25.30, oltre_31_5kg_alKG: 0.48 },
      { nation: 'Gran Bretagna-Isole Channel', range_0_5kg: 11.35, range_5_15kg: 16.60, range_15_31_5kg: 19.65, oltre_31_5kg_alKG: 0.50 },
      { nation: 'Spagna', range_0_5kg: 11.40, range_5_15kg: 16.60, range_15_31_5kg: 19.65, oltre_31_5kg_alKG: 0.40 },
      { nation: 'Francia(con P. di Monaco)', range_0_5kg: 11.40, range_5_15kg: 15.05, range_15_31_5kg: 19.25, oltre_31_5kg_alKG: 0.36 },
      { nation: 'Portogallo - Isole Baleari', range_0_5kg: 18.60, range_5_15kg: 24.00, range_15_31_5kg: 28.25, oltre_31_5kg_alKG: 0.51 },
      { nation: 'Irlanda, Rep.', range_0_5kg: 31.75, range_5_15kg: 35.80, range_15_31_5kg: 41.50, oltre_31_5kg_alKG: 0.52 },
      { nation: 'Irlanda del Nord', range_0_5kg: 31.75, range_5_15kg: 35.80, range_15_31_5kg: 41.50, oltre_31_5kg_alKG: 0.65 },
      { nation: 'Svizzera - Liechtenstein', range_0_5kg: 15.15, range_5_15kg: 22.45, range_15_31_5kg: 49.45, oltre_31_5kg_alKG: 1.23 },
      { nation: 'Polonia', range_0_5kg: 13.70, range_5_15kg: 19.20, range_15_31_5kg: 28.15, oltre_31_5kg_alKG: 0.60 },
      { nation: 'Danimarca', range_0_5kg: 18.15, range_5_15kg: 21.65, range_15_31_5kg: 26.65, oltre_31_5kg_alKG: 0.35 },
      { nation: 'Estonia', range_0_5kg: 28.05, range_5_15kg: 32.55, range_15_31_5kg: 38.45, oltre_31_5kg_alKG: 0.35 },
      { nation: 'Lettonia - Lituania', range_0_5kg: 28.05, range_5_15kg: 32.55, range_15_31_5kg: 38.45, oltre_31_5kg_alKG: 0.35 },
      { nation: 'Svezia', range_0_5kg: 19.65, range_5_15kg: 23.30, range_15_31_5kg: 27.45, oltre_31_5kg_alKG: 0.35 },
      { nation: 'Finlandia', range_0_5kg: 21.25, range_5_15kg: 26.60, range_15_31_5kg: 30.75, oltre_31_5kg_alKG: 0.35 },
      { nation: 'Norvegia', range_0_5kg: 41.85, range_5_15kg: 46.45, range_15_31_5kg: 52.20, oltre_31_5kg_alKG: 0.35 },
      { nation: 'Rep.Ceca', range_0_5kg: 11.45, range_5_15kg: 18.65, range_15_31_5kg: 21.95, oltre_31_5kg_alKG: 0.55 },
      { nation: 'Corsica', range_0_5kg: 49.70, range_5_15kg: 53.15, range_15_31_5kg: 57.50, oltre_31_5kg_alKG: 0.96 },
      { nation: 'Azzorre - Madeira', range_0_5kg: 41.40, range_5_15kg: 48.10, range_15_31_5kg: 52.45, oltre_31_5kg_alKG: 2.29 },
      {
        nation: 'Andorra - Isole Canarie Ceuta- Melilla', range_0_5kg: 67.75, range_5_15kg: 72.15, range_15_31_5kg: 76.95,
        oltre_31_5kg_alKG: 2.29
      }
    ];

    this.deliveryFissi = ['Fine-art', 'Carta cotone stampa', 'Carta fotografica stampa'];


    // CICLO LE ROTTE per creare i pulsanti laterali
    this.btnToggles = [];
    for (let i = 1; i < this.router.config.length; i++) {
      let routerId = null;
      let routerSort = null;
      let routerUrl = this.router.config[i].path;
      let routerTitle = null;
      let routerIsMenu = false;
      let isActive = true;
      if (this.router.config[i].data !== undefined) {
        routerId = this.router.config[i].data['id'];
        routerSort = this.router.config[i].data['sort'];
        routerTitle = this.router.config[i].data['title'];
        routerIsMenu = this.router.config[i].data['isMenu'];
        // isActive = this.GetIsActiveMenu(routerUrl);
        isActive = true;
      }
      let newBtn: BtnToggleConfig = {
        id: routerId,
        sort: routerSort,
        url: routerUrl,
        text: routerTitle,
        isMenu: routerIsMenu,
        isParameter: false,
        isActive: true
      };
      if (newBtn !== undefined) {
        this.btnToggles.push(newBtn);
      }
    }

    this.btnToggles = this.btnToggles.filter(r => r.isMenu === true); // .sort(r => r.sort * -1);

    this.btnToggles = this.btnToggles.sort((a, b) => {
      if (a.sort < b.sort) {
        return -1;
      } else if (a.sort > b.sort) {
        return 1;
      } else { return 0; }
    });


    // Categories
    this.models = [
      { id: 6, url: 'acrilico', name: 'Acrilico', resx: '', hasPackage: false },
      { id: 5, url: 'alluminio', name: 'Alluminio', resx: '', hasPackage: false },
      { id: 8, url: 'legno', name: 'Legno', resx: '', hasPackage: false },
      { id: 7, url: 'tela', name: 'Tela', resx: '', hasPackage: false },
      { id: 10, url: 'forex', name: 'Forex', resx: '', hasPackage: false },
      { id: 4, url: 'carte-e-supporti', name: 'Carte e Supporti', resx: '', hasPackage: false },
      { id: 9, url: 'zodio', name: 'Zodio', resx: '', hasPackage: false },
    ];

    // Products
    this.products = [
      {
        id: 33, idModel: 6, url: 'acrilico-1', resx: '', hasPackage: false,
        name: 'Stampa su vetro acrilico 5 mm con bianco',
        xml: 'acrilico'
      },
      {
        id: 27, idModel: 6, url: 'acrilico-2', resx: '', hasPackage: false,
        name: 'Stampa Topsec ® 3/5 mm',
        xml: 'topsec'
      },

      {
        id: 25, idModel: 5, url: 'alluminio-2', resx: '', hasPackage: false,
        name: 'Stampa diretta su alluminio Dibond bianco 3 mm',
        xml: 'dibond'
      },
      {
        id: 26, idModel: 5, url: 'alluminio-1', resx: '', hasPackage: false,
        name: 'Stampa diretta su alluminio Dibond grigio spazzolato 3 mm',
        xml: 'dibond_spazzolato'
      },
      {
        id: 24, idModel: 5, url: 'alluminio-3', resx: '', hasPackage: false,
        name: 'Stampa diretta su lamina di alluminio bianco 1 mm',
        xml: 'lamina_alluminio'
      },
      {
        id: 34, idModel: 5, url: 'alluminio-4', resx: '', hasPackage: false,
        name: 'Accoppiamento carta fotografica/cotone su alluminio Dibond 3 mm',
        xml: 'carta_accoppiata',
        preFilters: [
          {
            key: 'AccoppiamentoPannello',
            values: ['Dibond'],
            selectedValue: 'Dibond',
            showOnlyThis: true
          },
          {
            key: 'AccoppiamentoCarta',
            values: ['Fotografica', 'Cotone'],
            selectedValue: 'Fotografica'
          }
        ]
      },


      {
        id: 31, idModel: 8, url: 'legno-2', resx: '', hasPackage: false,
        name: 'Stampa diretta su legno 14 mm',
        xml: 'legno'
      },
      {
        id: 32, idModel: 8, url: 'legno-1', resx: '', hasPackage: false,
        name: 'Accoppiamento carta fotografica/cotone su legno 14 mm',
        xml: 'carta_accoppiata',
        preFilters: [
          {
            key: 'AccoppiamentoPannello',
            values: ['Legno'],
            selectedValue: 'Legno',
            showOnlyThis: true
          }
          ,
          {
            key: 'AccoppiamentoCarta',
            values: ['Fotografica', 'Cotone'],
            selectedValue: 'Fotografica'
          }
        ]
      },

      {
        id: 29, idModel: 7, url: 'tela-1', resx: '', hasPackage: false,
        name: 'Stampa su tela pittorica con telaio',
        xml: 'tela_pittorica_telaio'
      },
      {
        id: 28, idModel: 7, url: 'tela-2', resx: '', hasPackage: false,
        name: 'Stampa su tela pittorica',
        xml: 'tela_pittorica'
      },
      { id: 22, idModel: 4, url: 'carta-fotografica', resx: '', hasPackage: false, name: 'Carta fotografica', xml: 'carta_fotografica' },
      { id: 23, idModel: 4, url: 'carta-cotone', resx: '', hasPackage: false, name: 'Carta cotone', xml: 'carta_cotone' },
      {
        id: 30, idModel: 4, url: 'possibili-accoppiamenti', resx: '', hasPackage: false,
        name: 'Possibili accoppiamenti ',
        xml: 'carta_accoppiata',
        preFilters: [
          {
            key: 'AccoppiamentoPannello',
            values: ['Dibond', 'Forex', 'Simona', 'Legno'],
            selectedValue: 'Dibond'
          }
        ]
      },

      {
        id: 35, idModel: 10, url: 'forex', resx: '', hasPackage: false,
        name: 'Stampa diretta su Forex 5 mm',
        xml: 'forex'
      },


      // ZODIO PRODUCTS:
      //
      // PLEXI 3MM
      // DIBOND 3MM
      // CART FOT + FOREX 5
      // CART FOT + SIMO 10
      // CART FOT + SIMO 20
      // LEGNO MASSELLO DIRET.
      // TELA PITTORICA CON

      {
        id: 90, idModel: 9, url: 'zodio_plexi', resx: '', hasPackage: false,
        name: 'PLEXI 3MM',
        xml: 'zodio_plexi'
      },
      {
        id: 91, idModel: 9, url: 'zodio_dibond', resx: '', hasPackage: false,
        name: 'DIBOND 3MM',
        xml: 'zodio_dibond'
      },
      {
        id: 92, idModel: 9, url: 'zodio_carta_accoppiata', resx: '', hasPackage: false,
        name: 'CART FOTOGRAFICA ACCOPPIATA',
        xml: 'zodio_carta_accoppiata'
      },
      {
        id: 93, idModel: 9, url: 'zodio_legno', resx: '', hasPackage: false,
        name: 'LEGNO MASSELLO',
        xml: 'zodio_legno'
      },
      {
        id: 94, idModel: 9, url: 'zodio_tela_pittorica_telaio', resx: '', hasPackage: false,
        name: 'TELA PITTORICA CON TELAIO',
        xml: 'zodio_tela_pittorica_telaio'
      },

    ];




    // Nazioni di Spedizione
    this.shipmentNations = [
      { id: 'AT', name: 'Austria' },
      { id: 'BE', name: 'Belgio' },
      { id: 'DK', name: 'Danimarca' },
      { id: 'EE', name: 'Estonia' },
      { id: 'FI', name: 'Finlandia' },
      { id: 'DE', name: 'Germania' },
      { id: 'GR', name: 'Grecia' },
      { id: 'IT', name: 'Italia' },
      { id: 'LV', name: 'Lettonia' },
      { id: 'LT', name: 'Lituania' },
      { id: 'LU', name: 'Lussemburgo' },
      { id: 'NL', name: 'Paesi Bassi' },
      { id: 'PL', name: 'Polonia' },
      { id: 'PT', name: 'Portogallo' },
      { id: 'CZ', name: 'Repubblica Ceca' },
      { id: 'SK', name: 'Slovacchia' },
      { id: 'SI', name: 'Slovenia' },
      { id: 'ES', name: 'Spagna' },
      { id: 'SE', name: 'Svezia' },
      { id: 'HU', name: 'Ungheria' },
    ];

  }



  public getProductConfigFromName(prodname: string): ProductConfig {
    return this.products.filter(x => x.name === prodname)[0];
  }

  public getProductConfigFromIdProduct(idProduct: number): ProductConfig {
    return this.products.filter(x => x.id === idProduct)[0];
  }

  public getProductFromIdCateg(idModel: number): ProductConfig[] {
    return this.products.filter(x => x.idModel === idModel);
  }

}



// WEBPACK FOOTER //
// ./~/angular2-template-loader!./~/@angularclass/hmr-loader!./~/tslint-loader!./src/app/commons/config.service.ts